
import crypto from "crypto"
import conf from '../configs/index';
import Fecha from './type/Fecha'

export const isDef = val => typeof val !== "undefined"

export const BusinessErrorMessage = {
  '404': '请求的操作不存在！',
  '405': '服务器繁忙，请重试！',
};
export class BusinessError extends Error {
  constructor(message, code) {
      message = message || BusinessErrorMessage[code];
      super(message);
      this.stack = Error().stack;
      this.name = 'BusinessError';
      this.code = code;
      this.type = 'warning';
  }
  toErrorString() {
      return `${this.message}(${this.code})`;
  }
}

export const RequestErrorMessage = {
  '404': '请求的操作不存在！',
  '409': '请求服务出错，请联系管理员！',
};
export class RequestError extends Error {
  constructor(code, err) {
      let message;
      const res = err.response;
      if(res) message = res.data.msg;
      message = message || (RequestErrorMessage[code] || '处理数据时发生意外错误，请联系管理员！');
      super(message);
      this.stack = Error().stack;
      this.code = code;
      this.type = 'error';
      this.action = 'request';
      this.name = 'RequestError';
      this.response = res;
  }
  toErrorString() {
      return `${this.message}(${this.action}:${this.code})[${this.request.config.url}]`;
  }
}

export class UnexpectedError extends Error {
  constructor(message, action, stack) {
      super(message);
      this.action = action;
      this.code = code;
      this.type = 'error';
      this.stack = stack || Error().stack;
      this.name = 'UnexpectedError';
  }
  toErrorString() {
      return `${this.message}(${this.action})`;
  }
}

export function toData(ctx){
  return Promise.resolve(ctx.data);
}

export function respondData() {
  return (ctx)=>{
      const result = ctx.result;
      if(result instanceof Error){
        const res = result.response
        if(result.isAxiosError){
          if (!!res && res.status >= 400 && res.status <= 500 ) { //业务错误
            return Promise.reject(new BusinessError(res.data.msg, res.status));
          }
          //请求错误
          return Promise.reject(new RequestError(result.status, result))
        }
        return Promise.reject(result) //其他错误
      }
      //正常业务
      ctx.result = result.data;
      return Promise.resolve(ctx);
  }
}
export function handle(ctx) {
  if (ctx.data.code < 300) {
      return Promise.resolve(ctx.data.data);
  } else {
      return Promise.reject(new BusinessError(ctx.data.msg, ctx.data.code));
  }
}
export function errorHandle(err) {
  if(err.isAxiosError){
    return Promise.reject(new RequestError(err.status, err))
  }else{
    return Promise.reject(err)
  }
}


export function requestHandle() {
  return (ctx) => {
      return ctx
  }
};

export function setYear () {
    return (ctx) =>{
        const { result: { data } } = ctx
        if(!Array.isArray(data)) {
            return Promise.resolve(ctx)
        } else if(!data.length) {
            return Promise.resolve(ctx)
        } else {
            ctx.result.data.map(i => {
                let [Y, M] = [Fecha.format(i.postTime, 'YYYY'), Fecha.format(i.postTime, 'MM')]
                i.year = Math.max(M < 7 ? Y - 1 : Y, 2019)
            })
            return Promise.resolve(ctx)
        }
    }
}


/**
 * 获取当项目开始年份至今的所有年份选项
 *
 * @export
 * @param {number} [year=2019] 基础年份，默认为2019
 * @returns
 */
export const years = (i=2019) => {
    var fieldset = []
    var Year = new Date().getFullYear();
    var Month = new Date().getMonth()
    if( Month > 8){
        while(i < Year+1){
            fieldset.push({ id: i, name: i.toString()})
            i++;
        }
    }
    else{
        while(i < Year){
            fieldset.push({ id: i, name: i.toString()})
            i++;
        }
    }
    return fieldset.sort((a,b)=>a.id>b.id?-1:1)
}
/**
 * 双碳场景最小年份调为2024
 *
 * @export
 * @param {number} [year=2024] 基础年份，默认为2019
 * @returns
 */
export const carbon_years = (i=2024) => {
    var fieldset = []
    var Year = new Date().getFullYear();
    var Month = new Date().getMonth()
    if( Month > 8){
        while(i < Year+1){
            fieldset.push({ id: i, name: i.toString()})
            i++;
        }
    }
    else{
        while(i < Year){
            fieldset.push({ id: i, name: i.toString()})
            i++;
        }
    }
    return fieldset.sort((a,b)=>a.id>b.id?-1:1)
}

/**
 * 获取当前项目年份
 *
 * @export
 * @param {*} [date=new Date]
 * @returns
 */
export function getProductYear(date = new Date){
  return date.getMonth() > 7 ? date.getFullYear() : date.getFullYear() - 1
}

export function patchForDateHandle() {
    return (ctx) => {
        const result = ctx.result;
        result.created_at =  Fecha(result.created_at)
        result.updated_at =  Fecha(result.updated_at)
        return Promise.resolve(ctx);
    }
}

export function clearHTML(html) {
    return html.replace(/<[^>]*>/ig, '');
}

export const CHANNEL_REX = /^(频道)\/?(.+)?/
export const COLUMN_REX = /^(栏目)\/?(.+)?/

export const fetchScript = url => {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.type = `text/javascript`;
        //Firefoox, Opera, Chrome, Safari 3+
        script.onload = () => {
            //alert('Script loaded!')
            resolve('Script loaded!')
        };
        script.src = `${url}`;
        try {
            document.getElementsByTagName('body')[0].appendChild(script)
        } catch (err) {
            reject(err)
        }

    })
}

export const fetchStyle = function(url) {
    return new Promise((resolve, reject) => {
        let link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.onload = function() { resolve(); console.log('style has loaded'); };
        link.href = url;

        let headScript = document.querySelector('script');
        try {
            headScript.parentNode.insertBefore(link, headScript);
        } catch (err) {
            reject(err)
        }

    });
};

export const isMobile = function () { return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) }

// export const List = pattern=>data=>{
//     if(!(data instanceof Array)) throw new Error('The data must be Array.')
//     const _list = new Proxy(data, {
//         get: (obj, prop)=>{
//             if(prop in obj) return obj[prop]
//             if(prop === 'pattern') return pattern
//         },
//         set: (obj, prop, val)=>{
//             if(prop in obj) return obj[prop] = val
//             if(val.constructor === pattern) return obj[prop] = val
//             else throw new Error(`The pattern does not match, must use the ${pattern.name}`)
//         }
//     })
//     return _list
// }

export const find = (arr, fieldVal, fieldName='id') => {
  const finded = arr.find(item=>item[fieldName]==fieldVal)
  if(!finded) return {}
  return finded
}

export function renderFilterBar(list){
  return (fieldName, val, updateField='options')=>{
    const fieldset = list.find(fieldset=>fieldset.name===fieldName)
    fieldset[updateField] = val
  }
}
export function renderFilterBarList(vm, list = vm => vm.options.filter_rules) {
  return (fieldName, val, updateField = 'options') => {
    const _list = list(vm)
    const fieldset = _list.find(fieldset => fieldset.name === fieldName)
    fieldset[updateField] = val
  }
}

/**
 * 近30日时间区间
 *
 * @export
 * @param {*} [date=new Date()]
 * @returns
 */
export function getNearlyAMonth(date=new Date()){
  const lastTime = new Date(date)
  lastTime.setDate(lastTime.getDate()-30)
  return [date, lastTime]
}

/**
 * 上一个月时间区间
 *
 * @export
 * @param {*} [date=new Date()]
 * @returns
 */
export function getLastMonth (date=new Date()){
  const lastTime = new Date(date)
  lastTime.setMonth(lastTime.getMonth()-1)
  lastTime.setDate(1)
  const [start, end] = [new Date(lastTime), new Date(lastTime)]
  end.setMonth(date.getMonth()+1)
  end.setDate(0)
  return [start, end]
}

/**
 * 近7日时间区间
 *
 * @export
 * @param {*} [date=new Date()]
 * @returns
 */
export function getWeekRange(date=new Date()){
  const lastTime = new Date(date)
  lastTime.setDate(lastTime.getDate()-7)
    return [lastTime, date]
}
export function getMonthRange(rangeMonth=6, date=new Date()){
  const lastTime = new Date(date)
  lastTime.setMonth(lastTime.getMonth()-rangeMonth)
  return [lastTime, date]
}

export function md5(data){
  let str = new Buffer(data).toString('binary')
  return crypto.createHash('md5').update(str).digest('hex');
}

export function unique(array, fieldKey="id") {
    var res = array.filter(function(item, index, array){
        return array.map(item=>item[fieldKey]).indexOf(item[fieldKey]) === index;
    })
    return res;
}

export const List = pattern => data => { //TODO: remove here code to use @/utils/type/List
    if(!(data instanceof Array)) throw new Error('The data must be Array.')
    return data.map(item=>pattern(item))
}

export const defaultVal = (val, defaultVal) =>{ if(!val) return defaultVal; else return val }

export * from "./download"
export * from "./checker"
export * from "./redirect"
export * from "./conditioner"


export const flat = (fieldKeys=[],{prefix=true}={}) => {
  const firstStrUpper = str => str.substr(0,1).toUpperCase() + str.substr(1)
  const canFlat = val => !(Array.isArray(val) || typeof val != 'object')
  const flatObj = (attrVal,parentKey) =>  Object.keys(attrVal).reduce((result,next)=>({...result,[prefix?parentKey+firstStrUpper(next):next]:attrVal[next]}),{})
  return ctx =>{
    switch(ctx.hook){
      case 'after':
        if (Array.isArray(ctx.result)){
            ctx.result = ctx.result.map(item =>{
              fieldKeys.forEach(key=>{
                const attrVal = item[key]
                if(!canFlat(attrVal)) return
                const attrObj = flatObj(attrVal,key)
                item = { ...item, ...attrObj }
              })
              return item
            });
        }else{
          fieldKeys.forEach(key=>{
            const attrVal = ctx.result[key]
            if(!canFlat(attrVal)) return
            const attrObj = flatObj(attrVal,key)
            ctx.result = { ...ctx.result, ...attrObj }
          })
        }
        break;
      case 'before':
        let data = ctx.args.shift();

        fieldKeys.forEach(key=>{
          const attrVal = data[key]
          if(!canFlat(attrVal)) return
          const attrObj = flatObj(attrVal,key)
          data = { ...data, ...attrObj }
        })

        ctx.args = [data, ...ctx.args];
        break;
    }
    return ctx
  }
}


export const escapeSpecialChars = (value, debug=false)=>{
  if(debug) console.group("escapeSpecialChars")
  if(debug) console.log("value", value)
  value = value.replace(/\\n/g, "\n")
                .replace(/\\'/g, "\'")
                .replace(/\\"/g, '\\"')
                .replace(/\\&/g, "\&")
                .replace(/\\r/g, "\r")
                .replace(/\\t/g, "\t")
                .replace(/\\b/g, "\b")
                .replace(/\\f/g, "\f");
  if(debug) console.log("replace", value)
  if(debug) console.groupEnd("escapeSpecialChars")
  return value;
}
